import type { ReactNode } from 'react';

interface EmptyStateProps {
  icon?: ReactNode;
  title: string;
  caption: string;
  action?: ReactNode;
}

/** Centered empty state: circular icon, title, muted caption, optional CTA. */
export function EmptyState({ icon, title, caption, action }: EmptyStateProps) {
  return (
    <div className="rfp-empty">
      {icon && (
        <span aria-hidden="true" className="rfp-empty__icon">
          {icon}
        </span>
      )}
      <h3 className="rfp-empty__title">{title}</h3>
      <p className="rfp-empty__caption">{caption}</p>
      {action && <div className="rfp-empty__action">{action}</div>}
    </div>
  );
}
